import styled from 'styled-components';
import { Button } from '@mui/material';

export const SButton = styled(({ theme, ...props }) => <Button {...props} />)`
  && {
    color: ${({theme}) => theme.palette.colors.black100};
    border-color: ${({theme}) => theme.palette.colors.gray300};
    background-color: ${({theme}) => theme.palette.colors.gray100};
    border-width: 1.5px;
    :hover {
      color: ${({theme}) => theme.palette.colors.black100};
      border-color: ${({theme}) => theme.palette.colors.gray300};
      background-color: ${({theme}) => theme.palette.colors.gray200};
      border-width: 1.5px;
    }
  }
`;
